import { CooledProductsConflictItem, CooledProductsConflictRxItem } from '../CooledProductsConflictItem';

export const isRxItem = (item: CooledProductsConflictItem): item is CooledProductsConflictRxItem => item.isRx;
